<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Recuperar su contraseña</h4>
                                    <p>Capture su correo institucional para obtener instrucciones sobre como recuperar su contraseña.</p>
                                </div>
                                <vs-input type="email" label-placeholder="Correo" v-model="email" class="w-full mb-8" />
                                <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto">Regresar a Acceso</vs-button>
                                <vs-button :disabled=isDisabled @click="recuperar_cuenta()" class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0">Recuperar contraseña</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
export default {
    computed:{
        isDisabled() {
            // evaluate whatever you need to determine disabled here...
            if(this.act_btn == 1){
                return false
            }else{
                return true
            }

        }

    },
    data() {
        return {
            act_btn: 1,
            value1: '',
            email: ''
        }
    },
    methods: {
        recuperar_cuenta() {
            this.act_btn = 0;
            this.$http
                .get('recuperar_cuenta/' + this.email )
                .then(response => {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Cuenta',
                        text: 'Revise su correo para continuar con la recuperación de la contraseña'
                    })
                    //this.act_btn = 1;
                    this.$router.push('/pages/login')

                    }
                )


        }
    }
}
</script>
